import type { EvaluationKind, LevelLabel } from './types';
import { LEVEL_CELL_CLASS, LEVEL_LABEL_TEXT, computeLevel, levelLabel } from './riskUtils';

export interface ThresholdBand {
  maxValue: number;
  label: string;
  color: string;
}

export function classifyByThresholds(value: number, thresholds: ThresholdBand[]): LevelLabel {
  const sorted = [...thresholds].sort((a, b) => a.maxValue - b.maxValue);
  for (const band of sorted) {
    if (value <= band.maxValue) {
      return band.label as LevelLabel;
    }
  }
  const last = sorted[sorted.length - 1];
  return (last?.label as LevelLabel) ?? 'alto';
}

export function cellLevelValue(
  row: number,
  col: number,
  methodKind: EvaluationKind = 'prob_impacto',
): number {
  if (methodKind === 'prob_impacto') {
    return computeLevel(row, col);
  }
  return row * col;
}

export function cellStyleClass(
  row: number,
  col: number,
  methodKind: EvaluationKind,
  thresholds?: ThresholdBand[],
): string {
  const value = cellLevelValue(row, col, methodKind);
  if (thresholds && thresholds.length > 0) {
    const label = classifyByThresholds(value, thresholds);
    return LEVEL_CELL_CLASS[label] ?? LEVEL_CELL_CLASS.medio;
  }
  return LEVEL_CELL_CLASS[levelLabel(value)];
}

export function cellLevelText(
  row: number,
  col: number,
  methodKind: EvaluationKind,
  thresholds?: ThresholdBand[],
): string {
  const value = cellLevelValue(row, col, methodKind);
  if (thresholds && thresholds.length > 0) {
    const label = classifyByThresholds(value, thresholds);
    return LEVEL_LABEL_TEXT[label] ?? label;
  }
  return LEVEL_LABEL_TEXT[levelLabel(value)];
}
